module.exports = __webpack_public_path__ + "img/toxis-2.9bcf2445.jpg";